import { apiService } from '../../../core/api/BaseApiService';

export interface StartCallPayload {
  callerDeviceType?:   'web' | 'device';
  callerId:           string;
  receiverId:         string;
  receiverDeviceType: 'web' | 'device';
}

export interface StartCallResponse {
  isSuccess:  boolean;
  statusCode: number;
  response: {
    callSessionId:   string;
    VonageSessionId?: string;
    VonageToken?:     string;
  };
  error:   null | string;
  message: string;
}

export interface VideoTokenResponse {
  isSuccess:  boolean;
  statusCode: number;
  response: {
    token: string;
  };
  error:   null | string;
  message: string;
}

// Called by web when initiating a call to a device.
// Backend creates the call session, checks device WS status,
// and delivers INCOMING_CALL via WebSocket or FCM push.
// Requires Authorization header — uses apiService (has Bearer).
export const startCall = async (
  payload: StartCallPayload
): Promise<StartCallResponse> => {
  return apiService.post<StartCallResponse>('/call/start', payload);
};

// Called by BOTH web and device after CALL_ACCEPTED is received.
// Each side fetches their own unique JWT from the backend.
// Requires Authorization header — uses apiService (has Bearer).
export const getVideoToken = async (
  userId: string
): Promise<VideoTokenResponse> => {
  return apiService.get<VideoTokenResponse>(
    `/video/token`,
    { params: { userId } }
  );
};
